<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">

        <vx-card v-if="!is_on_create" v-can="'view-raw-material-orders'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full" v-if="!is_show_item_list && supplierId == ''">
              <label class="text-sm opacity-100 text-bold">Show all orders where this is used</label>
              <vs-switch v-model="is_internal_search" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">General</label>
              <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Item Status(Any Item within PO)</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['item-status']"
                         :options="['Pending','Not Accepted', 'Accepted', 'Pending Dispatch', 'Not Dispatched',
                         'Dispatched', 'Not Received', 'Received', 'Received - QC Passed', 'Received - QC Rejected',
                         'Returned', 'Cancelled']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Payment Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['payment-status']"
                         :options="['GRNI', 'Pre Invoice', 'Paid']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
          </div>
          <div class="vx-row mt-2">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="filters['date-from']"
                          placeholder="Choose Date From"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="filters['date-to']"
                          placeholder="Choose Date To"/>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-checkbox @input="onChangeDataType" v-model="is_show_item_list" class="" v-if="supplierId == ''">Show RM orders by items</vs-checkbox>
            </div>
          </div>
        </vx-card>

        <vx-card v-if="!is_on_create" :title="is_show_item_list ? 'RM ORDERS BY ITEM' : 'RM ORDERS'" >
          <template slot="actions" v-can="'create-edit-raw-material-orders'">
            <div class="flex">
              <excel-download v-if="!is_show_item_list" :name="'rm-order-sheet'" :filters="filters"/>
              <excel-download v-if="is_show_item_list" :name="'rm-order-items-sheet'" :filters="filters"/>
              <vs-button @click="onClickCreateNewOrder" class="mr-4 mb-4" color="primary" type="filled" v-if="supplierId == ''">Create new order</vs-button>
            </div>
          </template>
          <div v-can="'view-raw-material-orders'" slot="no-body" class="mt-4" v-if="is_display_table">
            <vs-table id="raw-material-orders-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort"   :sst="true" stripe class="table-dark-inverted vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" >DATE/TIME</vs-th>
                <vs-th width="10%" :sort-key="is_show_item_list ? 'order-code' : ''">ORDER CODE</vs-th>
                <vs-th width="10%" >SUPPLIER</vs-th>
                <vs-th width="10%" v-if="!is_show_item_list">DUE DATE</vs-th>
                <vs-th width="5%">AMOUNT</vs-th>
                <vs-th width="10%">ORDERED BY</vs-th>
                <vs-th width="20%" >RM ITEM(S)</vs-th>
                <vs-th width="10%" >STATUS</vs-th>
                <!-- <vs-th width="10%">PAYMENT STATUS</vs-th> -->
                <vs-th v-if="!is_show_item_list && $can('create-edit-sage-purchase-order')" width="10%" >SAGE ID</vs-th>
                <!-- <vs-th width="13%" >STATUS</vs-th> -->
                <vs-th width="5%" class="">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickDetailsView(is_show_item_list ? data[indextr].order_id : data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td class="text-sm	" :data="data[indextr].created_at">
                    {{__dateTimeFormatter(data[indextr].created_at)}}
                  </vs-td>

                  <vs-td  class="font-semibold" :class="generateState(indextr)" :data="data[indextr].purchase_order_code">
                    {{ data[indextr].purchase_order_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier">
                    <HyperLink :id="data[indextr].supplier.id" :type="'supplier'">
                      {{ data[indextr].supplier.company_name}}</HyperLink>
                  </vs-td>
                  <vs-td :data="data[indextr].required_by" v-if="!is_show_item_list">
                    {{ __dateTimeFormatterToDate(data[indextr].required_by)}}
                  </vs-td>

                  <vs-td>
                    <span v-if="!is_show_item_list && data[indextr].raw_material_items.length > 0">
                      {{ data[indextr].raw_material_items[0].currency | currency_code_formatter }}
                    </span>
                    <span v-if="is_show_item_list">
                      {{ data[indextr].currency | currency_code_formatter }}
                    </span>
                    {{ calculateTotalAmount(data[indextr])}}
                  </vs-td>

                  <vs-td :data="data[indextr].staff">
                    {{ data[indextr].staff}}
                  </vs-td>


                  <vs-td>
                    <span v-if="data[indextr].raw_material_items.length > 0 && !is_show_item_list" v-for="(item, index_item) in data[indextr].raw_material_items" :key="item.id">
                      <a @click.stop="onClickFinishedProduct(item.id)">{{item.category.prefix}}-{{ item.company_product_code }} ({{ item.company_product_name || 'N/A' }})</a>
                      <span v-if="data[indextr].raw_material_items.length !== index_item+1"> , </span>
                    </span>
                    <span v-if="is_show_item_list">
                      <a @click.stop="onClickFinishedProduct(data[indextr].raw_material_id)">{{data[indextr].category ? data[indextr].category.prefix : ''}}-{{ data[indextr].company_product_code }} ({{ data[indextr].company_product_name || 'N/A' }})</a>
                    </span>
                  </vs-td>
                  <vs-td :data="data[indextr].status">
                    {{ data[indextr].status && data[indextr].status.name ? data[indextr].status.name : '' }}
                  </vs-td>

                  <!-- <vs-td>
                    {{ paymentStatusGenerator(data[indextr].raw_material_items) }}
                  </vs-td> -->

                  <vs-td v-if="!is_show_item_list && $can('create-edit-sage-purchase-order')">
                    <span v-if="data[indextr].sage_purchase_order_id || data[indextr].sage_order_number">
                      {{ data[indextr].sage_order_number ? data[indextr].sage_order_number : data[indextr].sage_purchase_order_id}}
                    </span>
                    <span class="text-danger cursor-pointer" v-else>
                      <vx-tooltip class="mr-2" text="Sync order to sage" position="left">
                      <vs-button @click.stop="onClickSageSyncOrder(data[indextr])"
                                 size="small" color="danger" type="filled" icon-pack="feather" icon="icon-refresh-cw"/>
                      </vx-tooltip>
                    </span>
                  </vs-td>

                  <!-- <vs-td :data="data[indextr].status.name">
                    <vs-chip style="border-radius: 0" transparent>
                      {{ salesOrderStatusFactory(data[indextr].raw_material_items) }}
                    </vs-chip>
                  </vs-td> -->

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="mr-2" text="Order details view" position="left">
                        <vs-button @click="onClickDetailsView(is_show_item_list ? data[indextr].order_id : data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
<!--                      <vx-tooltip v-can="'create-edit-raw-material-orders'" class="mr-2" text="Update Order" position="left">-->
<!--                        <vs-button @click.stop="onClickProductOrderUpdate(data[indextr].id)"-->
<!--                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>-->
<!--                      </vx-tooltip>-->

                    </div>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"
              class="p-5"></vs-pagination>

          </div>
        </vx-card>
        <raw-material-price-list v-on:back="refreshData($event)" v-if="is_on_create"/>
      </div>
    </div>
    <update-rm-order-pop-up ref="updateRmOrderPopUp"/>
    <PartialItemsStatusChangePopUp ref="partialItemsStatusChangePopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  const InventoryRepository = RepositoryFactory.get('inventory')
  import UpdateRmOrderPopUp from '@/components/popups/inventory/rm-orders/UpdateRmOrderPopUp'
  import PartialItemsStatusChangePopUp from "@/components/popups/inventory/rm-orders/PartialItemsStatusChangePopUp";
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import ProductOrderTable from './ProductOrderTable'
  import RawMaterialPriceList from './RawMaterialPriceList'
  import {raw_material_order_statuses, raw_material_order_item_statuses} from '@/constants/statuses'
  import {defaultPagination, perPageList} from "@/constants/config";

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  const SageRepository = RepositoryFactory.get('sage')

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: '',
        is_on_create: false,
        viewDetailsOrder: {},
        perPage: defaultPagination,
        descriptionItems: perPageList,
        is_internal_search: false,
        raw_material_order_statuses: raw_material_order_statuses,
        raw_material_order_item_statuses: raw_material_order_item_statuses,
        is_show_item_list: false,
        is_display_table: true,
      }
    },
    components: {
      'v-select': vSelect,
      flatPickr,
      UpdateRmOrderPopUp,
      ProductOrderTable,
      RawMaterialPriceList,
      PartialItemsStatusChangePopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      if(this.supplierId == "" ) this.customerId = this.$route.params.id
      this.setFilterId('rm_orders_list_filters',['search','item-status','payment-status','date-from','date-to'])
      if (this.$route.query.open ) {
        this.is_on_create = true
      }
    },
    props: {
      supplierId: {
        default: "",
        required: false
      }
    },
    methods: {
      async refreshData () {
        this.is_on_create = false
        await this.getProductOrderList()
      },

      async onClickSageSyncOrder(data){
        let payload = {
          order_id: data.id,
          order_type: 'raw_material',
          supplier_id : data.sage_supplier_id,
          document_no: data.purchase_order_code,
          supplier_document_no: data.purchase_order_code,
          lines: data.raw_material_items.map((n) => {
            return {
              line_type:1,
              use_description:true,
              description: n.company_product_name || n.company_product_code,
              line_quantity: n.quantity+ '',
              allocated_quantity: n.quantity+ '',
              unit_buying_price: n.gbp_price + ''
            }
          })
        }
        if ( data.sage_supplier_id) {
          this.$vs.loading()
          try {
            await SageRepository.createRmOrder({orders: [payload]})
            await this.refreshData()
          } catch (error) {
            this.convertAndNotifyError(error)
          }
          this.$vs.loading.close()
        }
        else {
          this.$vs.dialog({
            color: 'danger',
            title: `Warning`,
            text: 'This Supplier is not synchronised on Sage. You must do that before you can attempt to synchronise any RM order.',
            acceptText: 'Close'
          })
        }

      },
      calculateTotalAmount(dataSet){
        try{
            let total = 0;
            if(!this.is_show_item_list) {
              dataSet.raw_material_items.forEach((m) => {
                if (!!m.price) {
                  total = total + Number(m.price) * Number(m.quantity)
                }
              })
            } else {
              total = Number(dataSet.price) * Number(dataSet.quantity)
            }
            return total.toFixed(2)
          }catch(e){}
        },
      async getProductOrderList() {
        this.$vs.loading()
        try {
          if(!this.is_show_item_list){
            const {data} = await InventoryRepository
              .getRmOrderList(this.page, this.filterQuery+`&is_internal_search=${this.is_internal_search}`,
              this.perPage, this.sort, this.supplierId)
            this.staff =  data.data
            this.meta = data.meta
          } else {
            const {data} = await InventoryRepository
              .getRmOrderByItemsList(this.page, this.filterQuery, this.perPage, this.sort)
            this.staff =  data.data
            this.meta = data.meta
          }
         
        } catch (error) {
          this.convertAndNotifyError(error)
        }
        this.$vs.loading.close()
      },

      async onClickProductOrderUpdate (id) {
        await this.$refs.updateRmOrderPopUp.openPopup(id)
      },
      onClickCreateNewOrder() {
        this.is_on_create = true
      },
      onClickDetailsView(id) {
        this.$router.push({path: `/pages/raw-materials/orders/${id}`})
      },

      filterQueryUpdate (){
        this.page = 1
        this.getProductOrderList()
      },

      handleChangePage(page) {
        this.page=page;
        this.getProductOrderList()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort = active+key;
          this.getProductOrderList()
        }
      },
      changePage(index) {
        this.page = 1
        this.perPage = this.descriptionItems[index]
      },
      ProductOrderStatusColorFactory(status_name) {
        let selected_status = this.raw_material_order_item_statuses.find((n) => n.name === status_name)
        return selected_status ?  selected_status.color : 'warning'
      },
      onClickFinishedProduct(id) {
        // this.$router.push({path: `/pages/formulations/${id}`})
      },
      onClickFormula(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      },
      async onClickStatusChangeConfirm(id, status, items) {
        if (['part_dispatched', 'part_received', 'part_return'].includes(status)) {
          await this.$refs.partialItemsStatusChangePopUp.openPopup(id, status, items)
        } else {
          this.$vs.dialog({
            type: 'confirm',
            color: 'primary',
            title: 'Confirm',
            text: 'Are you sure you want to make this change?',
            accept: this.onChangeSampleOrderStatus,
            parameters: [id, status]
          })
        }
      },
      async onChangeSampleOrderStatus(params){
        this.$vs.loading()
        try {
          await InventoryRepository.rmOrdersStatusChange(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.getProductOrderList()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      checkRmItemsAreEqual(items) {
        return items.map((n) => n.item_status).every( (val, i, arr) => val === arr[0] )
      },
      salesOrderStatusFactory(items) {
        const firstItemStatus = items[0].item_status;
        const allItemsHaveSameStatus = items.every(item => item.item_status === firstItemStatus);
        return (items.length === 1 ) ? firstItemStatus : (allItemsHaveSameStatus ? firstItemStatus : 'Multiple Items');
      },
      // paymentStatusGenerator(items) {
      //   const firstItemStatus = items[0].payment_status;
      //   const allItemsHaveSameStatus = items.every(item => item.payment_status === firstItemStatus);
      //   return (items.length === 1 ) ? firstItemStatus : (allItemsHaveSameStatus ? firstItemStatus : 'Multiple Items');
      // }
      async onChangeDataType() {
        this.is_display_table = false
        this.page = 1
        this.filters = {}
        this.sort = ''
        await this.getProductOrderList()
        this.is_display_table = true
      },
      generateState(index) {
        let current_order_code = this.staff[index].purchase_order_code
        let next_order_code = this.staff[index+1] ? this.staff[index+1].purchase_order_code : ''
        let previous_order_code = this.staff[index-1] ? this.staff[index-1].purchase_order_code : ''
        const classes = ['text-warning', 'text-danger']
        if (current_order_code === next_order_code || current_order_code === previous_order_code) {
          return classes[0]
        }
        return 'text-primary'
      }

    },
    watch : {
      page(){
        this.getProductOrderList()
      },
      perPage() {
        this.getProductOrderList()
      },
      is_internal_search: function () {
        this.getProductOrderList()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
